import { useMutation, useQuery } from '@tanstack/react-query';
import { request } from 'utils/request';

export const getFacebookLinkList = params => request.get('/api/v1/generate-link', { params });
export const createFacebookLink = data => request.post('/api/v1/generate-link', data);
export const updateFacebookLink = data => request.post('/api/v1/generate-link/update', data);
export const deleteFacebookLink = data => request.post('/api/v1/generate-link/delete', data);
export const deleteMultipleLink = data => request.post('/api/v1/generate-link/delete-multiple-url', data);
export const uploadFacebookImage = async data => {
  return await request.post('/api/v1/upload-image-link', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Mutation
export const useCreateFacebookLinkMutation = () => useMutation({ mutationFn: createFacebookLink });
export const useUpdateFacebookLinkMutation = () => useMutation({ mutationFn: updateFacebookLink });
export const useDeleteFacebookLinkMutation = () => useMutation({ mutationFn: deleteFacebookLink });
export const useDeleteMultipleLinkMutation = () => useMutation({ mutationFn: deleteMultipleLink });
export const useUploadFacebookImageMutation = () => useMutation({ mutationFn: uploadFacebookImage });

// Query
export const useQueryGetListFacebookLink = (params = {}, options = {}) =>
  useQuery({ queryKey: ['GET_FACEBOOK_LINK_LIST', params], queryFn: () => getFacebookLinkList(params), ...options });
